module.exports = __webpack_public_path__ + "img/ic_cover_qualify.a19705a0.png";